import moment from 'moment';
import { DateRangeGeneratorType } from '../types';

export const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const startOfMonth = moment().startOf('month');
export const endOfMonth = moment().endOf('month');

export const deafaultStartDate = ({ date }: DateRangeGeneratorType) => {
  if (moment(date)?.day() === 1) {
    return moment(date);
  }
  return moment(date)?.startOf('week')?.add(1, 'day');
};

export const deafaultLastDate = ({ date }: DateRangeGeneratorType) => {
  if (moment(date)?.day() === 0) {
    return moment(date);
  }

  return moment(date).endOf('week')?.add(1, 'day');
};
